import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from '@abyss/ui/form/hooks/useForm';
import { SelectList } from '@abyss/ui/form/SelectList';
import { Flex } from '@abyss/ui/base/Flex';
import { storage } from '@abyss/ui/tools/storage';
import { styled } from '@abyss/ui/tools/styled';

import { ProviderSelect } from './ProviderSelect';
import { EmulatedInput } from './EmulatedInput';
import { ProviderInput } from './ProviderInput';

const Heading = styled.h3({
  marginTop: 20,
});

const FixedWidthDiv = styled.div({
  marginTop: -15,
  marginLeft: 15,
  width: 300,
});

export const InternalUserForm = ({ uuid }) => {
  const form = useForm();
  const [history, setHistory] = useState([]);
  const [storedProvider, setStoredProvider] = useState();

  useEffect(() => {
    const localHistory = storage.local.get('internal-user:history') || [];
    setHistory(localHistory);

    if (localHistory[0]) {
      form.set('internalPreference', localHistory[0]);
      setStoredProvider(localHistory[0]);
    }
  }, []);

  const handleChange = value => {
    form.reset('emulation');
    form.set('internalPreference', value);
    setStoredProvider(value);
  };

  return (
    <React.Fragment>
      <Heading>Confirm Provider</Heading>
      <Flex>
        <Flex.Content space-60>
          <Flex gutters>
            <Flex.Content space-40 />
            <Flex.Content>
              <SelectList
                data-testid="servicing-ProviderName"
                value={storedProvider}
                options={history}
                onChange={handleChange}
                valueKey="servicingProviderMpin"
                labelKey="servicingProviderName"
                iaSearchable
                isClearable
                placeholder="Preference History..."
              />
            </Flex.Content>
          </Flex>
          <EmulatedInput />
          <ProviderInput />
        </Flex.Content>
        <Flex.Content>
          <FixedWidthDiv>
            <If condition={uuid}>
              <ProviderSelect uuid={uuid} />
            </If>
          </FixedWidthDiv>
        </Flex.Content>
      </Flex>
    </React.Fragment>
  );
};

InternalUserForm.propTypes = {
  uuid: PropTypes.string,
};

InternalUserForm.defaultProps = {
  uuid: null,
};
